import { ResourcesConfig } from 'aws-amplify';

const amplifyConfig: ResourcesConfig = {
  // AWS Amplify configuration
  // Update these values after running `amplify init` and `amplify push`
  //
  // Auth: {
  //   Cognito: {
  //     userPoolId: 'us-east-1_XXXXXXXXX',
  //     userPoolClientId: 'XXXXXXXXXXXXXXXXXXXXXXXXXX',
  //     identityPoolId: 'us-east-1:XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX',
  //     signUpVerificationMethod: 'code',
  //     loginWith: {
  //       email: true,
  //     },
  //   },
  // },
  // API: {
  //   GraphQL: {
  //     endpoint: 'https://XXXXXXXXXXXXXXXXXXXXXXXXXX.appsync-api.us-east-1.amazonaws.com/graphql',
  //     region: 'us-east-1',
  //     defaultAuthMode: 'apiKey',
  //     apiKey: 'da2-XXXXXXXXXXXXXXXXXXXXXXXXXX',
  //   },
  // },
};

export default amplifyConfig;
